/** Etiqueta legible de número de factura (prefijo + consecutivo, sin duplicar). */
export function getEtiquetaFactura(prefijo, numero, facturaId = null) {
    if (!facturaId && !prefijo && !numero) return null;

    const pref = String(prefijo ?? '').trim();
    const num = String(numero ?? '').trim();

    if ((num === '' || num === '0') && !pref) {
        return facturaId ? `Borrador#${facturaId}` : 'Borrador';
    }

    if (pref && num) {
        if (num.startsWith(`${pref}-`) || num === pref) {
            return num;
        }
        return `${pref}-${num}`;
    }

    if (num) return num;
    if (pref) return pref;
    return facturaId ? `#${facturaId}` : null;
}
